// 转化成后端要求的ids
import {
    glassTypes,
    glassTypeVale,
    bifocal,
    bifocalV,
    bifocalTop,
    bifocalTopV,
    multiFocus,
    multiFocusV,
    standardProgressive,
    standardProgressiveV,
    advancedProgressive,
    advancedProgressiveV,
} from "@/config/addToCarMap";
// import { stepsMapNum } from "@/config/lensStepsMap";

// import { packageMap } from "../../../commComponents/AddCart/packageAddCart";

interface IPackageUsageProps {
    rx?: string;
    isDecentered: boolean;
    usage: Record<string, any>;
}
export const getPackageUsage = ({
    rx,
    isDecentered,
    usage,
}: IPackageUsageProps) => {
    let ids: Record<string, any> = {};
    if (rx) {
        ids["id[rx]"] = rx;
        if (isDecentered) ids["id[94]"] = 403;
        if (usage.name === "distance") {
            ids[glassTypes] = glassTypeVale.distance;
        }

        if (usage.name === "near") {
            ids[glassTypes] = glassTypeVale.near;
        }
    } else {
        ids[glassTypes] = glassTypeVale.nonRx;
    }

    return ids;
};

// 根据用户选项转化成ids
// function getUsage(glassType, usages, cate, cb) {
//     const { usage, usageDetail } = usages;
//     let ids = {};
//     switch (true) {
//         // case glassType === 'nonPrescription' && cate === 6:
//         //   ids[glassTypes] = glassTypeVale.frameSunNonRx;
//         //   break;
//         case glassType === "nonPrescription":
//             ids[glassTypes] = glassTypeVale.nonRx;
//             break;
//         case usageDetail === "distance":
//             ids[glassTypes] = glassTypeVale.distance;
//             break;
//         case usageDetail === "intermediate":
//             ids[glassTypes] = glassTypeVale.intermediate;
//             break;
//         case usageDetail === "near":
//             ids[glassTypes] = glassTypeVale.near;
//             break;
//         case usageDetail === "roundTop":
//             ids[bifocal] = bifocalV;
//             ids[bifocalTop] = bifocalTopV.roundTop;
//             ids[multiFocus] = multiFocusV;
//             break;
//         case usageDetail === "bifocal":
//             ids[bifocal] = bifocalV;
//             ids[bifocalTop] = bifocalTopV.flatTop;
//             ids[multiFocus] = multiFocusV;
//             break;
//         case usageDetail === "standardPL":
//             ids[standardProgressive] = standardProgressiveV;
//             ids[multiFocus] = multiFocusV;
//             break;
//         case usageDetail === "advancedPL":
//             ids[advancedProgressive] = advancedProgressiveV;
//             ids[multiFocus] = multiFocusV;
//             break;
//         default:
//             this.error.usage = "PLS_CHOOSE_USAGE";
//             break;
//     }
//     this.usageIds = ids;
//     if (typeof cb === "function") cb(ids);
//     return this;
// }

// export class AddToCart {
//     constructor(props) {
//         this.error = {};
//         this.quantity = 1;
//     }

//     packageMap = packageMap;
//     getUsage = getUsage;

//     getLensType(lensType, cb) {
//         let ids = {};
//         const { key, lensColor, value } = lensType;

//         // 后端要求nocolor不传
//         if (key === "id[22]" && value === 273) {
//         } else if (key && value) {
//             ids[key] = value;
//         } else if (key && !value && lensColor) {
//             ids[key] = lensColor;
//             // 没有就报错
//         } else if (key && !value && !lensColor) {
//             this.error.lensType = "PLS_CHOOSE_COLOR";
//         } else {
//             this.error.lensType = "PLS_CHOOSE_LENSTYPE";
//         }
//         if (typeof cb === "function") cb(ids);
//         this.lensType = ids;
//         return this;
//     }

//     getThickness(thickness) {
//         let ids = {};
//         const { key, value } = thickness;
//         if (key) {
//             ids[key] = value;
//         } else {
//             this.error.thickness = "PLS_CHOOSE_LENSTHICKNESS";
//         }
//         this.thickness = ids;
//         return this;
//     }

//     getCoating(coat) {
//         let ids = {};
//         const { key, value } = coat;
//         if (key) {
//             ids[key] = value;
//         } else {
//             // default coating is no coating
//             // ids["id[19]"] = 270;
//             // this.error.coating = 'PLS_CHOOSE_COATING';
//         }
//         this.coating = ids;
//         return this;
//     }

//     getColor(color) {
//         let ids = {};
//         const { key, value } = color;
//         if (key) {
//             ids[key] = value;
//         } else {
//             this.error.color = "PLS_CHOOSE_COLOR";
//         }
//         this.color = ids;
//         return this;
//     }

//     setQuantity(num) {
//         this.quantity = num ? num : 1;
//         return this;
//     }

//     sub(
//         steps,
//         productId,
//         colorId,
//         isDecentered,
//         cate,
//         rx,
//         clipOnsData,
//         isPackage = {},
//         attachment = "",
//     ) {
//         const {
//             color,
//             error,
//             coating,
//             usageIds,
//             lensType,
//             thickness,
//             extra = {},
//             quantity,
//         } = this;
//         const clip = [];
//         for (var i in clipOnsData) {
//             if (parseInt(clipOnsData[i].quantity) > 0) {
//                 clip.push({
//                     id: clipOnsData[i].addons_id,
//                     quantity: clipOnsData[i].quantity,
//                 });
//             }
//         }

//         let ids = {
//             ...usageIds,
//             ...lensType,
//             ...isPackage,
//             ...thickness,
//             ...coating,
//             ...color,
//             ...extra,
//             clip,
//             product_id: productId,
//             color_id: colorId,
//             quantity,
//             attachment,
//         };
//         if (rx) ids["id[rx]"] = rx;
//         if (isDecentered) ids["id[94]"] = 403;
//         const promise = new Promise((res, rej) => {
//             const errors = hasError(steps, error);
//             if (errors[0]) {
//                 rej(errors);
//             } else {
//                 res(ids);
//             }
//         });
//         return promise;
//     }
// }

// 当前所有步骤是否有报错
// function hasError(steps, errors) {
//     let stepsMaps = {};
//     let actullyErrors = [];
//     for (let n of steps) {
//         for (let k in stepsMapNum) {
//             if (n === stepsMapNum[k]) {
//                 stepsMaps[k] = stepsMapNum[k];
//             }
//         }
//     }
//     for (let i in stepsMaps) {
//         for (let m in errors) {
//             if (m === i) {
//                 actullyErrors.push(errors[m]);
//             } else {
//             }
//         }
//     }
//     return actullyErrors;
// }

// AddToCart.prototype.getUsage = getUsage;
